import { Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { useSegments } from "api/segments";
import { FormButtons } from "components/FormControls/FormButtons";
import { TopHeader } from "components/Header/TopHeader/TopHeader";
import { InfoBox } from "components/Layout/InfoBox";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useNotifications } from "contexts/Toast/ToastProvider";
import { useMessage } from "hooks/intl";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { links } from "utilities/links";
import { Relations } from "../SingleSegment/Relations/Relations";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    wrapper: {
      display: "flex",
      justifyContent: "center",
      paddingTop: theme.spacing(12),
    },
    content: {
      width: "80%",
    },
    title: {
      fontWeight: 500,
      marginBottom: theme.spacing(4),
    },
    bolded: {
      fontWeight: 700,
    },
    info: {
      marginTop: theme.spacing(4),
      fontSize: 14,
    },
    buttons: {
      marginTop: theme.spacing(8),
    },
  }),
);

export function DeactivatedSegmentReview() {
  const classes = useStyles();
  const { message } = useMessage();
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const { id: segmentId } = useParams<{ id: string }>();
  const { useSegmentData, deactivateSegment } = useSegments({ segmentId });
  const { data: segmentData } = useSegmentData(segmentId);
  const { state } = useLocation();

  return (
    <>
      <TopHeader
        title={message({ id: "deactivateSegmentReview" })}
        clearLink={links.segmentsList}
      />
      <div className={classes.wrapper}>
        <div className={classes.content}>
          <Typography className={classes.title}>
            {message({ id: "deactivateSegment" })}
          </Typography>
          <InfoBox
            type="info"
            text={message(
              { id: "deactivateSegmentReviewInfoBox" },
              {
                span: (chunks: React.ReactNode[]) => (
                  <span className={classes.bolded}>{chunks}</span>
                ),
              },
            )}
          />
          <Typography className={classes.info}>
            {message(
              { id: "beforeDeactivatingSegmentReviewItemsInfo" },
              { name: segmentData?.name },
            )}
          </Typography>
          <Relations showLastRecalculation={false} />
          <FormButtons
            onCancelClick={() =>
              navigate(state?.prevPath || links.segmentsList)
            }
            onSubmitClick={async () => {
              const response = await deactivateSegment(segmentId as string);
              if (response) {
                navigate(state?.prevPath || links.segmentsList);
                notify(message({ id: "segmentDeactivated" }));
              }
            }}
            submitMessage="deactivateSegment"
            className={classes.buttons}
          />
        </div>
      </div>
    </>
  );
}
